import React from 'react'
import { ListGroupItem, Card, CardHeader, CardBody, ListGroup, Row, Col, Button, } from 'reactstrap'
import forOwn from 'mout/object/forOwn'
import sortByProps from '../../helpers/sortByProps';

/* ManageStudents

  <StudentsCard
    selectedSchool={this.props.selection.school}
    selectedStudent={this.props.selection.student}
    key='StudentsCard'
    select={this.props.select}
    students={this.props.students}
    schools={this.props.schools}
    openModal={this.props.openModal}
  />

*/

export default function StudentsCard({selectedSchool, selectedStudent, students, schools, openModal, select}) {
  let studentsCardBody = null

  if (selectedSchool && students) {
    let studentsListGroupItems = []
    studentsListGroupItems.push(
      <ListGroupItem
        key='studentsListGroupItemAdd'
        onClick={() => openModal('addStudent')}
        className='m2clickable'
      >
        + Add Student
      </ListGroupItem>
    )

    const school = schools[selectedSchool]

    if (school.students && students) {
      let studentsList = []
      forOwn(school.students, (check, studentId) => {
        if (check && students[studentId]) {
          if (students[studentId] && !students[studentId].deleted) {
            studentsList.push(students[studentId])
          }
        }
      })
      if (studentsList.length > 0) {
        const sortedStudentsList = sortByProps(studentsList, ['lastName', 'firstName'])
        sortedStudentsList.forEach((student) => {
          const active = student.id === selectedStudent
          studentsListGroupItems.push(
            <ListGroupItem
              key={`studentsListGroupItem${student.id}`}
              className={'m2clickable m2icon-hover'}
              onClick={() => openModal(`record&id=${student.id}`)}
            >
              {`${student.firstName} ${student.lastName}`} <i className="icon-magnifier icons ml-2"></i>
            </ListGroupItem>
          )
        })
      }
    }

    let buttonText = 'Create Registration Code'
    if (school.studentRegistrationCode) {
      buttonText = `Manage Registration Code: ${school.studentRegistrationCode}`
    }
    
    let manageRegistrationCode = (
      <Button 
        color='primary'
        onClick={() => openModal('studentRegistrationCode')}
      >
        {buttonText}
      </Button>
    )
    
    let importUsers = (
      <Button
        color='secondary'
        onClick={() => openModal('importStudents')}
        className='ml-2'
      >
        Import
      </Button>
    )

    studentsCardBody = (
      <CardBody>
        <Row className='mb-1'>
          <Col>
            {manageRegistrationCode}
            {importUsers}
          </Col>
        </Row>
        <ListGroup>
          {studentsListGroupItems}
        </ListGroup>
      </CardBody>
        
    )

  }

  return (
    <Card>
      <CardHeader>
        Students
      </CardHeader>
      {studentsCardBody}
    </Card>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/StudentsCard.js